<p-toast />
<p-confirmDialog />
<div class="px-6 py-4">
  <div class="flex justify-content-between mb-4">
    <p class="text-xl font-semibold">{{ 'layout.configurations.practices.title' | translate }}</p>
    <p-button
      *emPermission="Permission.CONFIG_BSA"
      class="p-button-success"
      icon="pi pi-plus"
      severity="success"
      (onClick)="onAdd()">
    </p-button>
  </div>
  <p-table
    [value]="practices"
    [paginator]="true"
    [rows]="10"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    paginatorPosition="bottom"
    paginatorAlignment="center"
    styleClass="w-full p-datatable-sm">
    <ng-template pTemplate="header">
      <tr>
        <th scope="col" pSortableColumn="name" class="bg-white">
          {{ 'layout.configurations.practices.name' | translate }}
          <p-sortIcon field="name" />
        </th>
        <th *emPermission="Permission.CONFIG_BSA" scope="col" class="bg-white w-10rem pl-3">
          {{ 'layout.configurations.practices.actions' | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-practice>
      <tr>
        <td>{{ practice.name }}</td>
        <ng-container *emPermission="Permission.CONFIG_BSA">
          <td class="px-4 py-2 flex flex-row-reverse flex-wrap gap-2">
            <p-button icon="pi pi-pencil" [outlined]="true" class="mr-2" (onClick)="onEdit(practice)"></p-button>
            <p-button
              icon="pi pi-trash"
              severity="danger"
              [outlined]="true"
              (onClick)="onDelete($event, practice.id)">
            </p-button>
          </td>
        </ng-container>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2" class="text-center py-4 text-color-secondary">
          {{ 'layout.configurations.practices.noDataFound' | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
